module.exports = __webpack_public_path__ + "static/img/rar.82837c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_files/rar.png
// module id = aKCp
// module chunks = 4